export default "__VITE_ASSET__CGnvCDi0__"